var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qk-image"},[_c('img',{class:_vm.getFit(_vm.fit),attrs:{"src":_vm.getSrc(_vm.imageSrc),"alt":"","crossOrigin":"anonymous"}})])}
var staticRenderFns = []

export { render, staticRenderFns }